import { useMutation } from "react-query";

import { apiGeneral, handleApiError, queryBuilder } from "services";

interface DescriptionRelation {
  id: number;
  description: string;
}

interface BusinessLineRelation extends DescriptionRelation {
  activity_division: string;
}

interface RiskRelation {
  id: number;
  name: string;
  classes: number;
}

export interface ProductReportData {
  code: number | null;
  description: string | null;
  business_line_id: number | null;
  product_type_id: number | null;
  conversion_factor: number | string | null;
  general_product_risk_id: number | null;
  risk_number: string | null;
  subsidiary_risk: number | string | null;
  uno_sap: number | null;
  packing_group: string | null;
  id_pallet_type: number | null;
  pallet_quantity: number | null;
  business_line?: BusinessLineRelation | null;
  product_type?: DescriptionRelation | null;
  risk?: RiskRelation | null;
  pallet_type?: DescriptionRelation | null;
}

export interface ProductReportFilters {
  code?: string;
  description?: string;
  business_line_id?: number;
  product_type_id?: number;
}

const getProductReport = async (
  filters: ProductReportFilters
): Promise<ProductReportData[]> => {
  try {
    const queryString = queryBuilder(filters);
    const { data } = await apiGeneral.get<ProductReportData[]>(
      `/products/report${queryString ? `?${queryString}` : ""}`
    );

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const useProductReport = () => useMutation(getProductReport);
